
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { spinner } from "../assets";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbwOY_YHdCLEmjsyb51VujQUGJqUyCy4xSGsYeWLMH8trW-ceF3o3762CB5Y-ebky-QTig/exec";

const initialFormData = {
  name: "",
  designation: "",
  organization: "",
  officeAddress: "",
  city: "",
  emailAddress: "",
  mobile: "",
  subject: "",
  query: "",
};

const fields = [
  { name: "name", label: "Full Name", placeholder: "Enter your full name", required: true },
  { name: "designation", label: "Designation", placeholder: "Enter your designation" },
  { name: "organization", label: "Organization", placeholder: "Enter organization name" },
  { name: "officeAddress", label: "Office Address", placeholder: "Enter your office address" },
  { name: "city", label: "City", placeholder: "Enter your city" },
  { name: "emailAddress", label: "Email Address", placeholder: "Enter your email address", type: "email", required: true },
  { name: "mobile", label: "Mobile Number", placeholder: "Enter your mobile number", type: "tel", required: true },
  { name: "subject", label: "Subject", placeholder: "Enter query subject", required: true },
];

export default function Queries() {
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify({
          formType: "Query",
          ...formData,
        }),
      });

      toast.info(
        "Request submitted."
      );
      setFormData({ ...initialFormData });
    } catch (error) {
      console.error("Query submission error:", error);
      toast.error("Unable to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full rounded-md border border-gray-300 bg-white px-3.5 py-3 text-sm text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-blue-600 focus:ring-2 focus:ring-blue-100";

  return (
    <section className="w-full bg-gray-50 px-4 py-8 sm:px-6">
      <ToastContainer position="top-right" autoClose={4000} />

      <div className="mx-auto max-w-4xl rounded-lg border border-gray-200 bg-white p-5 sm:p-8">
        <div className="mb-7">
          <h2 className="text-2xl font-semibold text-gray-900">
            Submit Your Query
          </h2>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            Please fill in the form below and tell us how we can help.
          </p>
          <p className="mt-3 text-xs text-gray-500">
            Fields marked <span className="text-red-500">*</span> are required.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-x-5 gap-y-5 sm:grid-cols-2">
            {fields.map((field) => (
              <div key={field.name}>
                <label
                  htmlFor={field.name}
                  className="mb-2 block text-sm font-medium text-gray-700"
                >
                  {field.label}
                  {field.required && (
                    <span className="ml-1 text-red-500">*</span>
                  )}
                </label>

                <input
                  id={field.name}
                  name={field.name}
                  type={field.type || "text"}
                  value={formData[field.name]}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  required={Boolean(field.required)}
                  maxLength={field.name === "mobile" ? 25 : 150}
                  autoComplete={
                    field.name === "emailAddress"
                      ? "email"
                      : field.name === "mobile"
                      ? "tel"
                      : field.name === "name"
                      ? "name"
                      : undefined
                  }
                  className={inputClass}
                />
              </div>
            ))}

            <div className="sm:col-span-2">
              <label
                htmlFor="query"
                className="mb-2 block text-sm font-medium text-gray-700"
              >
                Your Query <span className="text-red-500">*</span>
              </label>

              <textarea
                id="query"
                name="query"
                rows={5}
                value={formData.query}
                onChange={handleChange}
                placeholder="Write your query here..."
                maxLength={5000}
                required
                className={`${inputClass} resize-y`}
              />

              <p className="mt-1 text-right text-xs text-gray-400">
                {formData.query.length}/5000
              </p>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-blue-700 px-6 py-3 text-sm font-medium text-white transition hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? (
                <>
                  {spinner && (
                    <img
                      src={spinner}
                      alt=""
                      className="h-5 w-5 object-contain"
                    />
                  )}
                  Submitting...
                </>
              ) : (
                "Submit Query"
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
